import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  Wrapper,
  StyledLabel,
  ItemDescription,
  RadioInput,
  Mark,
  SuffixWrapper,
  InfoWrapper,
} from './styled';

const RadioButtons = ({ selected, items = [], onChange, name, disabled, row, style }) => {
  return (
    <Wrapper row={row} style={style}>
      {items?.map((item, index) => {
        const isSelected = String(selected) === String(item.value);
        
        return (
          <Fragment key={index.toString()}>
            <StyledLabel selected={isSelected} style={item.style} disabled={disabled}>
              <RadioInput
                name={name}
                type='radio'
                checked={isSelected}
                value={item.value}
                onChange={onChange}
                disabled={disabled}
              />
              <Mark />
              <InfoWrapper>
                {item.label}
                {item.description && (
                  <ItemDescription>{item.description}</ItemDescription>
                )}
                {item.suffix && <SuffixWrapper>{item.suffix}</SuffixWrapper>}
              </InfoWrapper>
            </StyledLabel>
            {!!item.relationView && isSelected && item.relationView}
          </Fragment>
        );
      })}
    </Wrapper>
  );
};

RadioButtons.propTypes = {
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  items: PropTypes.array,
  name: PropTypes.string,
  onChange: PropTypes.func,
  relationView: PropTypes.any,
  defaultChecked: PropTypes.any,
};

export default RadioButtons;
